export default function AsteriskMark({ size = 16 }: { size?: number }) {
  return (
    <svg viewBox="0 0 139 135" width={size} height={Math.round((size * 135) / 139)} aria-hidden="true" className="mark">
      <path d="M 45.402 135 L 14.668 112.674 L 38.766 79.884 L 0 66.628 L 11.874 30.698 L 50.291 43.605 L 50.291 0 L 88.709 0 L 88.709 43.605 L 127.126 30.698 L 139 66.628 L 100.234 79.884 L 124.332 112.674 L 93.598 135 L 69.5 102.209 L 45.402 135 Z" fill="currentColor" />
    </svg>
  );
}
